import { AxiosRequestConfig } from 'axios'
import instance from './instance'
import { setupInterceptors } from './interceptors'

// 初始化拦截器（仅执行一次）
setupInterceptors(instance)

/**
 * 发起 GET 请求。
 * @param url     请求路径
 * @param params  URL 查询参数
 * @param config  额外的 axios 配置（可传入 signal 用于取消请求）
 */
export function get<T>(url: string, params?: object, config?: AxiosRequestConfig): Promise<T> {
  return instance.get<T, T>(url, { params, ...config })
}

/**
 * 发起 POST 请求。
 * @param url    请求路径
 * @param data   请求体数据
 * @param config 额外的 axios 配置（可传入 signal 用于取消请求）
 */
export function post<T>(url: string, data?: object, config?: AxiosRequestConfig): Promise<T> {
  return instance.post<T, T>(url, data, config)
}

/**
 * 发起 PUT 请求。
 * @param url    请求路径
 * @param data   请求体数据
 * @param config 额外的 axios 配置（可传入 signal 用于取消请求）
 */
export function put<T>(url: string, data?: object, config?: AxiosRequestConfig): Promise<T> {
  return instance.put<T, T>(url, data, config)
}

/**
 * 发起 DELETE 请求。
 * @param url    请求路径
 * @param params URL 查询参数
 * @param config 额外的 axios 配置（可传入 signal 用于取消请求）
 */
export function del<T>(url: string, params?: object, config?: AxiosRequestConfig): Promise<T> {
  return instance.delete<T, T>(url, { params, ...config })
}

/**
 * 发起 PATCH 请求。
 * @param url    请求路径
 * @param data   请求体数据
 * @param config 额外的 axios 配置（可传入 signal 用于取消请求）
 */
export function patch<T>(url: string, data?: object, config?: AxiosRequestConfig): Promise<T> {
  return instance.patch<T, T>(url, data, config)
}

/** 上传请求的默认超时（毫秒）。文件体积远大于普通 JSON 请求，放宽到 60s。 */
const UPLOAD_TIMEOUT = 60_000

/**
 * 发起 multipart/form-data 上传请求。
 *
 * 必须走本函数而非 {@link post}：axios 实例默认带 `Content-Type: application/json`，
 * 而 axios 的 transformRequest 见到 JSON content-type 会把 FormData 走
 * `formDataToJSON` 序列化成 JSON —— 文件会被静默丢弃。这里强制覆盖为
 * multipart/form-data，浏览器 adapter 随后会补上 boundary。
 *
 * @param url    请求路径
 * @param data   FormData 请求体
 * @param config 额外的 axios 配置（可传入 onUploadProgress 显示进度、signal 取消请求）
 */
export function upload<T>(url: string, data: FormData, config?: AxiosRequestConfig): Promise<T> {
  return instance.post<T, T>(url, data, {
    timeout: UPLOAD_TIMEOUT,
    ...config,
    headers: { ...config?.headers, 'Content-Type': 'multipart/form-data' },
  })
}

export default instance
